import { combineReducers } from 'redux';
import sidebarReducer from './sidebar/sidebarSlice';

import userReducer from './user/userSlice';

// const rootReducer = combineReducers({
//   user: userReducer,
//   sidebar: sidebarReducer,
// });

const rootReducer = combineReducers({
  user: userReducer,
  sidebar: sidebarReducer,
});


export default rootReducer;
